import { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import moment from "moment-timezone";
import { getSocket } from '../context/socket'; // Adjust path if needed

const ChecklistDeadlinePopup = ({ onCancel, togglePopup, cardId, checklistItemId }) => {
    const socket = getSocket();

    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);

    const [reminderDate, setReminderDate] = useState(today);
    const [dueDate, setDueDate] = useState(tomorrow);

    const handleReminderChange = (date) => {
        const endOfDay = moment(date).endOf('day').toDate(); // Set time to 23:59:59
        setReminderDate(endOfDay);
    };
    
    const handleDueDateChange = (date) => {
        const endOfDay = moment(date).endOf('day').toDate(); // Set time to 23:59:59
        setDueDate(endOfDay);
    };
    const handleSave = () => {
        const dueDateIST = dueDate
            ? moment(dueDate).subtract(5, 'hours').subtract(30, 'minutes').format("YYYY-MM-DD HH:mm:ss")
            : null;

        const reminderDateIST = reminderDate
            ? moment(reminderDate).startOf('day').subtract(5, 'hours').subtract(30, 'minutes').format("YYYY-MM-DD HH:mm:ss")
            : null;

        socket.emit('updateCardDates', {
            card_id: cardId,
            checklistItemId: checklistItemId,
            due_date: dueDateIST,
            reminder_date: reminderDateIST
        });

        onCancel();
    };


    const handleRemove = () => {
        onCancel();
    };

    return (
        <div className="popup-box popup-dates">
            <div className="popup-header">
                Dates
                <Button icon="pi pi-times" className="p-button-text close-btn" onClick={() => togglePopup("dates")} />
            </div>
            <div className="popup-body">
                <div className="list-EmpLIst">
                    <p className="text-muted mb-1"><small>Set Deadline Date</small></p>
                    <Calendar
                        value={dueDate}
                        onChange={(e) => handleDueDateChange(e.value)}
                        placeholder="Select due date"
                        dateFormat="dd-mm-yy"
                        className="mb-3"
                        minDate={new Date()} // ⬅️ disables all past dates
                    />

                    <p className="text-muted mb-1"><small>Set Reminder Date</small></p>
                    <Calendar
                        value={reminderDate}
                        onChange={(e) => handleReminderChange(e.value)}
                        placeholder="Select reminder date"
                        dateFormat="dd-mm-yy"
                        className="mb-3"
                        minDate={new Date()} // ⬅️ disables all past dates
                    />

                    <Button label="Save" severity="primary" className="border-0 py-1 px-3 mt-2 me-2" onClick={handleSave} />
                    <Button label="Cancel" severity="danger" className="border-0 py-1 px-3 mt-2 opacity-75" onClick={handleRemove} />
                </div>
            </div>
        </div>
    );
};

export default ChecklistDeadlinePopup;
